import * as React from 'react'
import Box from '@mui/material/Box'

import { ResultsPagination } from './ResultsPagination'
import DialogActions from '@mui/material/DialogActions/DialogActions'
import { BackButton } from '../BackButton'
import { CancelButton } from '../CancelButton'

type FooterProps = {
  showPaginationSkeleton: boolean
}

export function Footer(props: FooterProps) {
  const { showPaginationSkeleton } = props

  return (
    <Box>
      <Box display="flex" flexDirection="column">
        {!showPaginationSkeleton && <ResultsPagination />}
      </Box>
      <DialogActions
        sx={{
          px: 2.4,
          pb: 2.4,
        }}
      >
        <CancelButton />
        <BackButton />
      </DialogActions>
    </Box>
  )
}
